// Autenticación con Firebase: se puede entrar con GOOGLE o como INVITADO (anónimo, sin registro).
// De la cuenta de Google se toma el nombre y la foto para el perfil del jugador.
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInAnonymously,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
  signOut,
} from 'firebase/auth';

// Config pública del proyecto Firebase (se puede incrustar en el cliente sin riesgo).
const firebaseConfig = {
  apiKey: 'AIzaSyAE8nf-zYfpua4QNR57ndR5Il9g03YlyL8',
  authDomain: 'palabriks.firebaseapp.com',
  projectId: 'palabriks',
  storageBucket: 'palabriks.firebasestorage.app',
  messagingSenderId: '490125155558',
  appId: '1:490125155558:web:5c7f42abc41ebb10432f27',
  measurementId: 'G-ETY6D7RH1G',
};

export class AuthManager {
  constructor() {
    this.app = initializeApp(firebaseConfig);
    this.auth = getAuth(this.app);
    this.provider = new GoogleAuthProvider();
    this.provider.setCustomParameters({ prompt: 'select_account' }); // permite elegir cuenta
    this.user = null;
    this._listeners = [];
    this._ready = false;
  }

  /** Se suscribe a cambios de sesión (login / logout). */
  onChange(fn) { this._listeners.push(fn); }
  _emit() { for (const fn of this._listeners) { try { fn(this.user); } catch (_) {} } }

  /**
   * Inicializa la sesión: recupera la que hubiera guardada (persistencia local) y resuelve
   * un posible login por redirección (móvil). Devuelve el usuario actual (o null).
   */
  async init() {
    try { await setPersistence(this.auth, browserLocalPersistence); } catch (_) {}
    try { await getRedirectResult(this.auth); } catch (_) { /* sin redirección pendiente */ }
    return new Promise((resolve) => {
      onAuthStateChanged(this.auth, (user) => {
        this.user = user || null;
        if (!this._ready) { this._ready = true; resolve(this.user); }
        this._emit();
      });
    });
  }

  /** Abre el login de Google. Usa popup y, si el navegador lo bloquea, cae a redirección. */
  async signIn() {
    try {
      await signInWithPopup(this.auth, this.provider);
    } catch (e) {
      const code = e?.code || '';
      if (code === 'auth/popup-blocked'
        || code === 'auth/cancelled-popup-request'
        || code === 'auth/operation-not-supported-in-this-environment') {
        await signInWithRedirect(this.auth, this.provider);
        return;
      }
      if (code === 'auth/popup-closed-by-user') return; // el usuario cerró la ventana: sin error
      throw e;
    }
  }

  /** Entra como INVITADO (anónimo, sin registro). Da una sesión con uid propio. */
  async signInAnon() {
    await signInAnonymously(this.auth);
  }

  async signOutUser() { try { await signOut(this.auth); } catch (_) {} }
}
